



















import { Component, Vue } from "vue-property-decorator";
import InputSEPSimple from "@/components/InputSEPSimple.vue";
import { storeDokter } from "@/store/modules/dokter";
import ReferensiUnit from "@/store/modules/new/ReferensiUnit";
import BpjsVclaimSearchBar from "@/components/bpjs_vclaim/BpjsVclaimSearchBar.vue";
import InputSEP from "@/pages/PendaftaranPage/InputSEP.vue";
import RiwayatSEP from "./PendaftaranPage/RiwayatSEP.vue";

@Component({
  components: {
    InputSEPSimple,
    BpjsVclaimSearchBar,
    InputSEP,
    RiwayatSEP
  }
})
export default class InputSepPage extends Vue {
  mounted() {
    if (!storeDokter.list.length || !storeDokter.listAll.length) {
      // storeDokter.act_dokter_all();
    }

    ReferensiUnit.getUnit();
  }
}
